import { TInvoiceLine } from "@/types";

/** Currencies offered in the form's select; the API takes any ISO 4217 code. */
export const INVOICE_CURRENCIES = ["EUR", "USD", "GBP", "CHF", "CAD"] as const;

/** Units suggested under the unit input; the field stays free text. */
export const INVOICE_UNIT_KEYS = ["day", "hour", "flat", "unit"] as const;

export const DEFAULT_PAYMENT_TERMS_DAYS = 30;

export const EMPTY_INVOICE_LINE: TInvoiceLine = {
	label: "",
	description: "",
	quantity: 1,
	unit: "",
	unitPrice: 0,
	vatApplicable: false,
	vatRate: null,
};

export const INVOICE_LIST_PAGE_SIZE = 20;
